import script from "./OrganismsChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganismsChart.vue?vue&type=script&lang=ts&setup=true"

import "./OrganismsChart.vue?vue&type=style&index=0&id=f78c9912&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f78c9912"]])

export default __exports__